import { render, staticRenderFns } from "./CourseSubPack.vue?vue&type=template&id=d318e64e&scoped=true&"
import script from "./CourseSubPack.vue?vue&type=script&lang=ts&"
export * from "./CourseSubPack.vue?vue&type=script&lang=ts&"
import style0 from "./CourseSubPack.vue?vue&type=style&index=0&id=d318e64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d318e64e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d318e64e', component.options)
    } else {
      api.reload('d318e64e', component.options)
    }
    module.hot.accept("./CourseSubPack.vue?vue&type=template&id=d318e64e&scoped=true&", function () {
      api.rerender('d318e64e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/CourseSubPack.vue"
export default component.exports